var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect7, _rect8, _rect9, _rect10, _circle, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmptyTnc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 286,
    viewBox: "0 0 350 286",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1048 75.8596C-22.4153 143.328 53.3732 203.512 98.4574 225.171C161.713 255.56 295.927 268.95 330.768 175.678C369.464 72.0866 107.005 -8.4755 35.1048 75.8596Z",
    fill: "#F4F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.818 88.3203H74V185.411H239.818V88.3203Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244.818 80.0742H79V177.165H244.818V80.0742Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 88.7266,
    width: 37.0997,
    height: 88.3006,
    fill: "#BABABB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.168,
    y: 100.777,
    width: 23.5402,
    height: 3.44826,
    rx: 1.72413,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.168,
    y: 106.812,
    width: 16.8614,
    height: 3.44826,
    rx: 1.72413,
    fill: "#C2C1C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.168,
    y: 112.848,
    width: 21.2409,
    height: 3.44826,
    rx: 1.72413,
    fill: "#DBDBDB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 86.168,
    y: 118.875,
    width: 15.3285,
    height: 3.44826,
    rx: 1.72413,
    fill: "#C0C0C0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 86.168,
    y: 124.91,
    width: 23.5402,
    height: 3.44826,
    rx: 1.72413,
    fill: "#D7D7D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M244.899 80H79V90.8194H244.899V80Z",
    fill: "#BABABB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5782 87.2204C86.5814 87.2204 87.3947 86.4094 87.3947 85.409C87.3947 84.4086 86.5814 83.5977 85.5782 83.5977C84.575 83.5977 83.7617 84.4086 83.7617 85.409C83.7617 86.4094 84.575 87.2204 85.5782 87.2204Z",
    fill: "#EB5757"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0959 85.3938C93.0966 85.7522 92.9906 86.1028 92.7914 86.4011C92.5923 86.6995 92.3088 86.9322 91.9769 87.0698C91.6451 87.2075 91.2797 87.2438 90.9271 87.1743C90.5746 87.1048 90.2506 86.9326 89.9962 86.6794C89.7418 86.4262 89.5684 86.1035 89.4981 85.752C89.4277 85.4005 89.4634 85.0361 89.6008 84.7049C89.7382 84.3738 89.971 84.0906 90.2698 83.8915C90.5686 83.6923 90.92 83.5859 91.2794 83.5859C91.7605 83.5859 92.222 83.7763 92.5626 84.1152C92.9031 84.4542 93.0949 84.914 93.0959 85.3938V85.3938Z",
    fill: "#FFD88D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9786 87.2204C97.9818 87.2204 98.7951 86.4094 98.7951 85.409C98.7951 84.4086 97.9818 83.5977 96.9786 83.5977C95.9754 83.5977 95.1621 84.4086 95.1621 85.409C95.1621 86.4094 95.9754 87.2204 96.9786 87.2204Z",
    fill: "#1EB89C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M229.999 126.198L231.48 117.32",
    stroke: "black",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.776 178.724L203.295 187.602",
    stroke: "black",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M236.325 127.601L242.775 121.324",
    stroke: "black",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.013 175L192 179.098",
    stroke: "black",
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 107.32,
    width: 58,
    height: 5,
    rx: 2.5,
    fill: "#D0D0D0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 117.32,
    width: 89,
    height: 5,
    rx: 2.5,
    fill: "#BABABB",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 127.32,
    width: 73,
    height: 5,
    rx: 2.5,
    fill: "#BABABB",
    fillOpacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 137.32,
    width: 42,
    height: 5,
    rx: 2.5,
    fill: "#BABABB",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 225.149,
    cy: 157.469,
    r: 23.6486,
    fill: "#EFEFEF",
    stroke: "#FCDF98",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M223.948 162.054H227.577C227.577 157.284 234 156.883 234 150.802C234 146.76 230.625 144.32 225.399 144.32C221.153 144.32 217.996 145.813 216 148.399L218.649 150.292C220.101 148.435 222.206 147.416 225.145 147.416C228.411 147.416 230.335 149.018 230.335 151.348C230.335 155.536 223.948 156.337 223.948 162.054ZM225.798 170.32C227.141 170.32 228.121 169.264 228.121 167.99C228.121 166.679 227.141 165.659 225.798 165.659C224.419 165.659 223.44 166.679 223.44 167.99C223.44 169.264 224.419 170.32 225.798 170.32Z",
    fill: "#EB5757"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225 139.82C229.333 139.987 239.1 143.12 243.5 154.32",
    stroke: "white",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M270.375 197.693L243.251 173.833L240.253 176.582L265.94 202.408C267.263 203.738 269.437 203.669 270.673 202.256C271.848 200.913 271.715 198.872 270.375 197.693Z",
    fill: "#FCDF98"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyTnc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-tnc.a640abb4.svg";
export { ForwardRef as ReactComponent };